import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { useAssistant } from "../assistant/AssistantProvider";
import { LightArc } from "../LightArc";
import { DESTINATIONS } from "./sections";
import { Sparkles, LogOut } from "lucide-react";

export default function Sidebar({ fraction }) {
  const { user, logout } = useAuth();
  const { openAssistant } = useAssistant();
  const navigate = useNavigate();
  const loc = useLocation();

  return (
    <aside className="hidden md:flex flex-col fixed inset-y-0 left-0 w-64 bg-paper border-r border-hairline z-50" data-testid="app-sidebar">
      <div className="px-6 pt-6 pb-4">
        <Link to="/home" className="flex items-center gap-2" data-testid="nav-logo">
          <img src="/brand/symbol-color.svg" alt="" className="h-6 w-auto" />
          <span className="font-display font-medium text-2xl tracking-tight text-ink">wandr</span>
        </Link>
        <LightArc fraction={fraction} className="mt-4" />
      </div>

      <div className="px-4 mb-3">
        <button onClick={() => openAssistant()} className="btn-swiss btn-outline w-full text-sm !justify-between" data-testid="sidebar-ask-ai">
          <span className="inline-flex items-center"><Sparkles size={15} className="mr-2" /> Ask AI</span>
          <kbd className="font-mono text-[10px] text-ink-faint">⌘K</kbd>
        </button>
      </div>

      <nav className="flex-1 px-4 py-1 space-y-1" data-testid="sidebar-nav">
        {DESTINATIONS.map((d) => {
          const active = loc.pathname.startsWith(d.root);
          const Icon = d.icon;
          return (
            <Link
              key={d.key}
              to={d.path}
              data-testid={`sidebar-${d.key}`}
              className={`flex items-center gap-3 px-3.5 py-2.5 rounded-full text-sm font-medium transition-colors ${
                active ? "bg-ember/10 text-ember-press" : "text-sand-600 hover:bg-sand-100 hover:text-ink"
              }`}
            >
              <Icon size={17} strokeWidth={active ? 2.4 : 2} />
              {d.label}
            </Link>
          );
        })}
      </nav>

      <div className="px-5 py-4 border-t border-hairline flex items-center justify-between gap-2">
        <span className="text-xs text-sand-500 truncate font-mono" data-testid="sidebar-user-email">{user?.email}</span>
        <button
          onClick={async () => { await logout(); navigate("/auth"); }}
          className="btn-swiss btn-ghost text-xs px-2.5 py-1.5 shrink-0"
          data-testid="nav-logout"
          title="Log out"
        >
          <LogOut size={14} />
        </button>
      </div>
    </aside>
  );
}
